export default __webpack_public_path__ + "static/media/1m-points.8fd8b13f.svg";